(($) => {
  $('.fbt-toogle-options').on('click', (e) => {
    e.preventDefault();
    var $this = $(e.target);
    var $productCard = $this.parents('.product-card');
    $productCard.find('.product-variant').show();
  });

  $('.close-options').on('click', (e) => {
    e.preventDefault();
    var $this = $(e.target);
    $this.parent().hide();
  });

  $('.single-option-selector-frequently').on('change', (e) => {
    e.preventDefault();
    var $this = $(e.target);
    var selectedOption = $this.val();
    var $productCard = $this.parents('.product-card');
    var productVariant = window.productVariants[$productCard.attr('data-bundle-product-id')];
    if (productVariant) {
      var selectedVariant = window.productVariants[4571326873713].filter((e) => e.option1 == selectedOption)[0];
      var $productImage = $productCard.find('product-image img');
      $productImage.attr('src', selectedVariant.featured_image.src);

      $('#ProductSelect-' + $productCard.attr('data-bundle-product-id')).val(selectedVariant.id).trigger('change');

      var $productPrice = $productCard.find('.product-price');
      if (selectedVariant.compare_at_price) {
        $productPrice.find('.price__current').addClass('price__compare-at').addClass('visible').addClass('price__compare-at--single').text('$' + selectedVariant.compare_at_price / 100);
        $productPrice.find('.price__current--on-sale').text('$' + selectedVariant.price / 100);
      } else {
        $productPrice.find('.price__current').text('$' + selectedVariant.price / 100);
        $productPrice.find('.price__current--on-sale').empty();
      }
    }

    var $productBundlePrice = $('.products-grouped-action .product-price');
    var $priceList = $('.frequently-bought-together-content .isChecked .price__current:not(.price__compare-at), .frequently-bought-together-content .isChecked .price__current--on-sale').filter((k, el) => $(el).text() !== '');
    var totalPrice = 0;
    $priceList.each((k, el) => totalPrice += parseFloat($(el).text().replace('$', '')));
    if (window.bundleDiscountRate && window.bundleDiscountRate > 0) {
      $productBundlePrice.find('.price-item--sale').text('$' + (totalPrice * (1 - window.bundleDiscountRate)).toFixed(2));
      $productBundlePrice.find('.price-item--regular').text('$' + totalPrice.toFixed(2));
    } else {
      $productBundlePrice.find('.price-item--regular').text('$' + totalPrice.toFixed(2));
    }
  });


  $('.fbt-checkbox input').on('change', (e) => {
    var $this = $(e.target);
    $this.parents('.product-card').toggleClass('isChecked');

    var $productBundlePrice = $('.products-grouped-action .product-price');
    var $priceList = $('.frequently-bought-together-content .isChecked .price__current:not(.price__compare-at), .frequently-bought-together-content .isChecked .price__current--on-sale').filter((k, el) => $(el).text() !== '');
    var totalPrice = 0;
    $priceList.each((k, el) => totalPrice += parseFloat($(el).text().replace('$', '')));
    if (window.bundleDiscountRate && window.bundleDiscountRate > 0) {
      $productBundlePrice.find('.price-item--sale').text('$' + (totalPrice * (1 - window.bundleDiscountRate)).toFixed(2));
      $productBundlePrice.find('.price-item--regular').text('$' + totalPrice.toFixed(2));
    } else {
      $productBundlePrice.find('.price-item--regular').text('$' + totalPrice.toFixed(2));
    }
  });

  /* const addToCart = async ($productCard) => {


    return await $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: $form.serialize()
      })
      .then(function (result) {
        // ???
      })
      .catch(function (error) {
        var warning = '<p class="warning animated bounceIn">Could not complete adding all items to cart!</p>';
        $('.product-form--atc-button').after(warning);
      });
  }*/

  $('.products-grouped-action .product-form--atc-button').on('click', (e) => {
    e.preventDefault();

    var $allCheckedProducts = $('.frequently-bought-together_form .product-card.isChecked');
    let formData = {
      'items': []
    };
    for (var i = 0; i < $allCheckedProducts.length; i++) {
      var $productCard = $($allCheckedProducts[i]);

      formData.items.push({
        'id': $productCard.find('[name=group_id]').val(),
        'quantity': 1
      });
    };

    // double check on the selected value
    /*let formData = {
      'items': [{
        'id': $productCard.find('[name=group_id]').val(),
        'quantity': 1
      }]
    };*/
    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        window.location = '/cart';
      })
      .catch((error) => {
        var warning = '<p class="warning animated bounceIn">Could not complete adding all items to cart!</p>';
        $('.products-grouped-action .product-form--atc-button').after(warning);
      });

  });
})(jQuery)